var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12"},[_c('ejs-treeview',{ref:"measureTreeForDataQueryForResourceReport",attrs:{"fields":_vm.fieldsOfMeasureTreeForResourceReport,"nodeSelected":_vm.measureTreeNodeSelectedForResourceReport}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }